import { render } from "./BkGully.vue?vue&type=template&id=4d0b4d04&scoped=true"
import script from "./BkGully.vue?vue&type=script&lang=js"
export * from "./BkGully.vue?vue&type=script&lang=js"

import "./BkGully.vue?vue&type=style&index=0&id=4d0b4d04&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0b4d04"]])

export default __exports__